// @flow
import {createSelector} from "reselect";
import type {State} from "../../Store";
import {LatLngEnum} from "../../../Utils/AppUtils";
import isEmpty from "lodash/isEmpty";

const tokenDataSelector = (state: State) => state.tokenData;

const isTokenDecrypted = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return !!(tokenData && !isEmpty(tokenData));
    }
);

const getOriginType = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return tokenData.origin_type;
    }
);

const getDestType = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return tokenData.dest_type;
    }
);

const isOriginForcePolygon = createSelector(
    getOriginType,
    (originType) => {
        return originType === LatLngEnum.FORCE_POLYGON;
    }
);

const isDestForcePolygon = createSelector(
    getDestType,
    (destType) => {
        return destType === LatLngEnum.FORCE_POLYGON;
    }
);

const getTokenDataError = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return tokenData.error;
    }
);

const isTokenDataInvalid = createSelector(
    getTokenDataError,
    (tokenError) => {
        return !!(tokenError);
    }
);

const getTokenOrigin = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return {
            lat: tokenData.origin_lat,
            lng: tokenData.origin_lng,
            type: tokenData.origin_type,
        };
    }
);

const getTokenDest = createSelector(
    tokenDataSelector,
    (tokenData) => {
        return {
            lat: tokenData.dest_lat,
            lng: tokenData.dest_lng,
            type: tokenData.dest_type,
        };
    }
);

export default {
    tokenDataSelector,
    getOriginType,
    getDestType,
    isOriginForcePolygon,
    isDestForcePolygon,
    getTokenDataError,
    isTokenDataInvalid,
    isTokenDecrypted,
    getTokenOrigin,
    getTokenDest,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/TokenData/selectors.js